<template>
  <v-flex xs12 md6 mb-4>
    <v-card>
      <v-card-media
        class="white--text"
        height="150px"
        src="/static/playlist_img01.jpg"
      >
        <v-container fill-height fluid>
          <v-layout fill-height>
            <v-flex xs12 align-end flexbox>
              <span class="headline">進行プレイリスト
              </span><br>
              <p>お客様の進行内容に合わせてプレイリストを作成し、曲をお選びください。</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-media>
      <v-list two-line>
        <draggable :list="items" v-bind:options="options" @end="onEnd">
          <v-list-tile v-for="(item, index) in $store.state.playlist_a" :key="item.rank" avatar>
            <v-list-tile-avatar>
              <ListAvatar
                :sceneId="item.scene_id"
                :itemIndex=parseInt(index)
                :itemTitle="item.name"
                :productId=parseInt(item.product_id)
                :itemArtist="item.artist_name"
                :itemLyrics="item.lyrics"
                :itemSrc="item.mp3"
                :musicPlayerType="'playListA'"
              />
            </v-list-tile-avatar>
            <playListContent :item="item" :index="index" :playListType=1 />
            <div v-if="item.comment !== ''">
              <v-tooltip top>
                <v-btn flat icon color="amber darken-3" slot="activator">
                  <v-icon>comment</v-icon>
                </v-btn>
                <div style="max-width: 400px;">{{ item.comment }}</div>
              </v-tooltip>
            </div>
            <div v-if="dragHandle && playListCommit == false" class="drag-handler">
              <v-icon color="grey lighten-1" class="draggable_icon">import_export</v-icon>
            </div>
            <more-btn
              :addIsumBtn="true"
              :addOthersBtn="true"
              :addCommentBtn="true"
              :musicBtn="true"
              :addMusicBtn="item.product_id"
              :addListBtn="false"
              :addFavoriteBtn="false"
              :deleteListBtn="true"
              :customerPlaylistProductId="item.customer_playlist_product_id"
              :productId="item.product_id"
              :commentText="item.comment"
              :playListType="1"
              :propIsumCode="item.isum_code"
              :propIsumSongName="item.isum_song_name"
              :propIsumArtistName="item.isum_artist_name"
              :propSceneId="item.scene_id"
              :propOtherName="item.other_song_name"
              :propOtherArtistName="item.other_artist_name"
              :propIsumType="item.isum_type"
              :itemIndex=index
              @updateParentPlayList="findCustomerPlayListA(1)"
            />
          </v-list-tile>
        </draggable>
      </v-list>
      <v-card-actions v-if="playListCommit == false && items.length < $store.getters.getTuneLimit">
        <v-btn color="primary" dark outline @click.stop="adddialog = true" style="width:100%;">
          <v-icon left dark>add_circle_outline</v-icon>
          シーンを追加
        </v-btn>
      </v-card-actions>
    </v-card>
    <p v-if="items.length < $store.getters.getTuneLimit" class="grey--text darken-1 text-xs-right">{{ items.length }}/ {{$store.getters.getTuneLimit}}</p>
    <p v-else class="red--text darken-1 text-xs-right">セットできる上限に達しました。</p>
    <v-dialog v-model="adddialog" max-width="300px">
      <v-card>
        <v-card-title>
          追加するシーンを選択
        </v-card-title>
        <v-card-text>
          <v-select
            :items="scenes"
            v-model="scenes_select"
            label="シーン選択"
            item-text="sceneName"
            item-value="id"
            single-line
          >
            <template slot="selection" slot-scope="data">
              <v-chip
                :selected="data.selected"
                :key="JSON.stringify(data.item)"
                @input="data.parent.selectItem(data.item)"
              >
                <v-avatar>
                  <img :src="data.item.avatar">
                </v-avatar>
                {{data.item.sceneName }}
              </v-chip>
            </template>
            <template slot="item" slot-scope="data">
              <template v-if="typeof data.item !== 'object'">
                <v-list-tile-content v-text="data.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-avatar>
                  <img :src="data.item.avatar">
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="data.item.sceneName"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat @click.stop="adddialog=false">キャンセル</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="appendSceneToPlayList()">追加</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import CustomerPlayListService from '@/components/services/CustomerPlayListService.vue'
import SceneService from '@/components/services/SceneService.vue'
import IsumService from '@/components/services/IsumService.vue'
import ListAvatar from '@/components/atoms/ListAvatar.vue'
import draggable from 'vuedraggable'
import MoreBtn from '@/components/MoreBtn.vue'
import playListContent from '@/components/Modules/playListContent'
export default {
  name: 'PlayListA',
  components: {
    draggable,
    MoreBtn,
    ListAvatar,
    playListContent
  },
  data () {
    return {
      users: [],
      info: null,
      adddialog: false,
      items: [],
      scenes_select: [],
      scenes: [],
      dragHandle: true,
      options: {
        animation: 200,
        forceFallback: true,
        handle: '.drag-handler'
      }
    }
  },
  props: ['playListCommit'],
  mounted () {
    this.findCustomerPlayListA(1)
    this.scenes = SceneService.findAll()
  },
  methods: {
    /**
     * 新郎新婦のプレイリスト情報を取得する
     **/
    findCustomerPlayListA (playlistType) {
      let transactionId = this.$store.state.transactionId
      CustomerPlayListService.findCustomerPlayList(playlistType, transactionId, (response) => {
        this.items = response
        this.$log.debug('methods: findCustomerPlayListA', this.items)
        IsumService.isNotExistDuplicationIsumTuneInPlayList()
      }, (error) => {
        this.$log.error(error)
      })
      this.logging('methods: findCustomerPlayListA END', 'playListType:' + playlistType)
    },
    onEnd: function (evt) {
      let formData = new URLSearchParams()
      formData.append('transactionid', this.$store.state.transactionId)
      var index = 0
      this.items.map(record => {
        formData.append(index, record.customer_playlist_product_id)
        index++
      })
      // 順序をアップデート
      CustomerPlayListService.updatePlayListRank(formData, (response) => {
        this.$log.debug(response)
        if (response.success) {
          this.findCustomerPlayListA(1)
        }
      }, (error) => {
        this.$log.error(error)
        this.errorDia = true
      })
    },
    getSceneIconPath (SceneId) {
      return SceneService.findIconPathBySceneId(SceneId)
    },
    /**
     * 進行プレイリストに新しくシーンを追加する
     **/
    appendSceneToPlayList () {
      this.$log.debug('methods: appendSceneToPlayList START')
      if (this.scenes_select === undefined || this.scenes_select === null) {
        return
      }
      let formData = new URLSearchParams()
      formData.append('scene_id', this.scenes_select)
      formData.append('playlist_type', 1)
      formData.append('transactionid', this.$store.state.transactionId)
      CustomerPlayListService.addPlayList(formData, 1, this.$store.state.transactionId, (response) => {
        this.logging(response)
        this.addDialog = false
        this.scenes_select = null
        this.findCustomerPlayListA(1)
      }, (error) => {
        this.logging(error)
        this.errorDia = true
      })
      this.adddialog = false
      this.$log.debug('appendSceneToPlayList END')
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar img {
  border-radius: 0%!important;
}
.sortable-chosen {
  opacity: 0.7;
  background-color:#CFD8DC;
  .draggable_icon {
    color: #EE6492!important;
  }
}
.sortable-ghost {
  background-color:#EEEEEE;
}
.drag-handler {
  &:hover {
    cursor: move;
  }
}
.v-enter-active {
  transition: all .8s ease;
}
.v-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.v-enter, .v-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/PlayListA.vue